<button data-test="tgoXPq70" class="close-btn" (click)="close()">
  <span data-test="izmRrGRp" class="badge badge_gray">
    <i data-test="GyWECI9D" class="material-icons md-12">close</i>
  </span>
</button>
<h1
  data-test="ZFF3aU2x"
  class="mat-dialog-title"
  style="text-align: center; padding-top: 24px"
  *ngIf="confirmData.title || confirmData.description"
>
  {{ confirmData.title || confirmData.description }}
</h1>
<div data-test="6NU2DSXM" mat-dialog-content style="padding: 16px 24px 24px;">
  <p
    *ngIf="confirmData.description && confirmData.title"
    data-test="fMdMIONt"
    style="text-align: center"
    [innerHTML]="confirmData.description"
  ></p>
  <ng-content></ng-content>
</div>
<footer
  data-test="hcEmH2Xy"
  class="rs-modal-actions modal__footer_white modal__footer_grow"
>
  <div data-test="rFpXsOVl" class="modal__container">
    <div
      data-test="Lqo_MoIo"
      class="row align-items-center justify-content-center gutters-20"
    >
      <div data-test="rXpCJ7G9" class="col" *ngIf="confirmData.cancelBtn">
        <button
          data-test="NzT8fUTA"
          class="button_ button button_secondary button_text-14"
          (click)="cancel()"
        >
          {{ confirmData.cancelBtn }}
        </button>
      </div>
      <div data-test="EMltjDA3" class="col">
        <button
          data-test="zyDgx3r9"
          class="button_ button button_primary button_text-14"
          data-close="modal"
          [disabled]="disabled || forceDisabled"
          (click)="confirm()"
        >
          {{ confirmData.confirmBtn }}
        </button>
      </div>
    </div>
  </div>
</footer>
